import React from 'react'
import aqua1 from '../../../images/aqua1.png'
import aqua2 from '../../../images/aqua2.png'
import aqua3 from '../../../images/aqua3.png'
import aqua4 from '../../../images/aqua4.png'
import aqua5 from '../../../images/aqua5.png'
import aqua6 from '../../../images/aqua6.png'
import aqua7 from '../../../images/aqua7.png'

const interiors_general = () => {
  return (
    <div className='uk-container'>
        
                       <div className='row'>
                           <div className='col-sm-8'>
                                   <div
                                   style={{ backgroundImage: `url(${aqua1})`,
                                   backgroundRepeat: 'no-repeat',
                                   backgroundSize: 'cover',
                                   paddingBottom: '50px',
                                   paddingTop: '100px',
                                   height: '60vh'
                               }} >

                                </div>
                               </div>

                           <div className='col-sm-4'>
                                     <div
                                     style={{ backgroundImage: `url(${aqua2})`,
                                     backgroundRepeat: 'no-repeat',
                                     backgroundSize: 'cover',
                                     paddingBottom: '50px',
                                     paddingTop: '100px',
                                     height: '60vh'
                                 }}>
                           </div>
                                  </div>
                       </div>




                       

                        <div className='uk-margin-small-top'>
                       <div className='row'>
                            <div className='col-sm-4'>
                                <div
                                    style={{ backgroundImage: `url(${aqua3})`,
                                    backgroundRepeat: 'no-repeat',
                                    backgroundSize: 'cover',
                                    paddingBottom: '50px',
                                    paddingTop: '100px',
                                    height: '60vh'
                                }}
                                >

                                </div>
                            </div>

                            <div className='col-sm-4'>
                                <div
                                   style={{ backgroundImage: `url(${aqua4})`,
                                   backgroundRepeat: 'no-repeat',
                                   backgroundSize: 'cover',
                                   paddingBottom: '50px',
                                   paddingTop: '100px',
                                   height: '60vh'
                               }}
                                >

                                </div>
                            </div>


                            <div className='col-sm-4'>
                                <div
                                  style={{ backgroundImage: `url(${aqua5})`,
                                  backgroundRepeat: 'no-repeat',
                                  backgroundSize: 'cover',
                                  paddingBottom: '50px',
                                  paddingTop: '100px',
                                  height: '60vh'
                              }}
                                
                                >

                                </div>
                            </div>
                       </div>
                       </div>




                       
                      <div className='uk-margin-small-top'>
                       <div className='row'>
                            <div className='col-sm-6'>
                                 <div
                                      style={{ backgroundImage: `url(${aqua6})`,
                                      backgroundRepeat: 'no-repeat',
                                      backgroundSize: 'cover',
                                      paddingBottom: '50px',
                                      paddingTop: '100px',
                                      height: '60vh'
                                  }}
                                 >

                                 </div>
                            </div>


                            <div className='col-sm-6'>
                            <div
                                      style={{ backgroundImage: `url(${aqua7})`,
                                      backgroundRepeat: 'no-repeat',
                                      backgroundSize: 'cover',
                                      paddingBottom: '50px',
                                      paddingTop: '100px',
                                      height: '60vh'
                                  }}
                                 >

                                 </div>
                            </div>
                       </div>
                       </div>














    </div>
  )
}

export default interiors_general